export enum StockRecordStatus {
  INCOMPLETE = 'INCOMPLETE',
  ON = 'ON',
  OFF = 'OFF',
  PENDING = 'PENDING',
  PROTOTYPE = 'PROTOTYPE'
}
